import request from '@/utils/request'

export function getProjects(branchId, size, page, find) {
  return request({
    url: `/msma/projects/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find
    }
  })
}

export function getProjectById(branchId, id) {
  return request({
    url: `/msma/projects/id/${branchId}/${id}`,
    method: 'get'
  })
}

export function findProjects(branchId, find) {
  return request({
    url: `/msma/projects/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function createProjects(branchId, data) {
  return request({
    url: `/msma/projects/create/${branchId}`,
    method: 'post',
    data
  })
}

export function duplicateProjects(branchId, id) {
  return request({
    url: `/msma/projects/duplicate/${branchId}/${id}`,
    method: 'post'
  })
}

export function updateProjects(branchId, id, data) {
  return request({
    url: `/msma/projects/id/${branchId}/${id}`,
    method: 'put',
    data
  })
}

export function removeProjects(branchId, id) {
  return request({
    url: `/msma/projects/id/${branchId}/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/msmaProjects.js